export default __webpack_public_path__ + "static/img1-c6ac23e72a8aa8c852f5332a4971c1ab.jpg";